import GroupLoadForm from "../CreateLoadGroup/LoadsForm/GroupLoadForm";

export default GroupLoadForm;